/**
 * PendingMessageBubble Component
 * 
 * Renders a pending user message with microphone waveform visualization
 */

import AudioWaveform from '../common/AudioWaveform';

interface PendingMessageBubbleProps {
  transcriptInProgress?: string;
  getMicrophoneFrequencyData?: () => Uint8Array;
  isUserSpeaking?: boolean;
  isWaitingForTranscript?: boolean; // User stopped speaking, waiting for OpenAI transcription
}

export default function PendingMessageBubble({ 
  transcriptInProgress, 
  getMicrophoneFrequencyData,
  isUserSpeaking = false,
  isWaitingForTranscript = false
}: PendingMessageBubbleProps) {
  return (
    <div className="flex items-start gap-2 md:gap-3 justify-end pr-3 md:pr-8">
      <div className="p-2 md:p-3 rounded-lg bg-green-600/20 backdrop-blur-sm border border-green-400/10 max-w-[75%] md:max-w-md">
        <div className="flex items-center gap-3">
          {/* Show waveform when user is actively speaking */}
          {getMicrophoneFrequencyData && isUserSpeaking && (
            <div className="flex-shrink-0">
              <AudioWaveform
                isActive={isUserSpeaking}
                barCount={7}
                colorFrom="rgb(74, 222, 128)" // green-400
                colorTo="rgb(34, 197, 94)"   // green-500
                getFrequencyData={getMicrophoneFrequencyData}
              />
            </div>
          )}
          
          {/* Show loading spinner when waiting for transcription */}
          {isWaitingForTranscript && !transcriptInProgress && (
            <div className="flex-shrink-0">
              <div className="animate-spin rounded-full h-4 w-4 border-2 border-green-400 border-t-transparent"></div>
            </div>
          )}
          
          {/* Show transcript in progress if available */}
          {transcriptInProgress && (
            <span className="text-gray-300 text-xs md:text-sm italic">
              {transcriptInProgress}
            </span>
          )}
        </div>
      </div>
      <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-green-500/70 flex-shrink-0"></div>
    </div>
  );
}

